import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const useMockups = (open, generationId, opts) => {
  const [mock, setMock] = useState({ loading: false, urls: [] });
  const { type, size, color } = opts;

  useEffect(() => {
    if (!open || !generationId) return undefined;
    let live = true;
    setMock({ loading: true, urls: [] });
    const t = setTimeout(() => api.post("/merch/mockup", { generation_id: generationId, product_type: type, size, color })
      .then((r) => live && setMock({ loading: false, urls: r.data.mockups }))
      .catch(() => live && setMock({ loading: false, urls: [] })), 400);
    return () => { live = false; clearTimeout(t); };
  }, [open, generationId, type, size, color]);

  return mock;
};
